import { UIUtilIconResources } from "../util/IconResourses";
import { Table } from "./Tabla";
import { Sortable } from '@shopify/draggable';

type PickTableConfig<Data> = Pick<Table.IConfig<Data>, "IdTabla" | "Parent">
    & Pick<Table.IConfig<Data>["EvaluatorAndSubLevelsBuild"], "OnStepRowTable" | "OnStepCellTable">

type Config<Data> = {
    // IdTabla: string
    Columns: Table.IConfig<Data>["RenderColumnHeadings"],

} & PickTableConfig<Data>

export type TablaRowManagerConfig<Data> = Config<Data>

export class TablaRowManager<Data> {
    private tabla: Table.Tabla<Data>
    private data: Data[]

    constructor(config: Config<Data>) {
        this.data = []

        this.tabla = new Table.Tabla({
            ...config,
            IdTabla: "tabla_editable_" + config.IdTabla,
            MinWidth: 250,
            HideCheckboxes: true,
            Resizable: false,
            FilterByStrSearch: "none",
            Columns: [
                { Field: "__order" as any, Label: "", Width: "1%", MinWidth: "15px", IsSortable: false },
                ...config.Columns.map(d => {
                    return {
                        ...d,
                        IsSortable: false,
                        // >> Agregar configuraciones por columna
                    }
                }),
                {
                    Field: "__actions" as any,
                    Label: "",
                    MinWidth: "40px",
                    Width: "10%",
                    IsSortable: false,
                    OnLoadHead: (container) => {
                        container.append("wc-button")
                            .attr("dim", "24")
                            .property("_SrcIco", UIUtilIconResources.CGeneral.Add)
                            .classed("btn_round", true)
                            .style("cursor", "pointer")
                            .on("click", () => {
                                // >> Agregar item en blanco
                                this.AddEmptyItem()
                            });
                    }
                }
            ],
            RenderColumnHeadings: null,
            EvaluatorAndSubLevelsBuild: {
                OnStepRowTable: (datum, tableRow, rowBody, ...args) => {

                    if (config.OnStepRowTable) {
                        config.OnStepRowTable(datum, tableRow, rowBody, ...args)
                    }
                },
                OnStepCellTable: (cell, datum, field, indexInitialOfDatum) => {
                    cell.style("user-select", "none")

                    if (!!config.OnStepCellTable && !["__order", "__actions"].includes(field)) {
                        config.OnStepCellTable(cell, datum, field, indexInitialOfDatum)
                    }
                    if (field == "__order") {
                        cell.classed("btn_order", true)
                            .style("transform", "rotate(90deg)")
                            .style("color", "gray")
                            .style("cursor", "grab")
                            .text("|||");
                    }
                    if (field == "__actions") {
                        cell.text("")
                        cell.append("wc-button")
                            .attr("dim", "24")
                            .property("_SrcIco", UIUtilIconResources.CGeneral.Eliminar)
                            .classed("btn_round", true)
                            .style("cursor", "pointer")
                            .on("click", () => {
                                // >> Agregar item en blanco
                                this.RemoveItem(datum)
                            });
                    }
                }
            },
        })

        this.tabla._Control.style("min-height", "80px")

        const dragContainer = this.tabla._Control.select<HTMLDivElement>(".rbodyB").node()

        const sortable = new Sortable(dragContainer, {
            draggable: '.tr_body',
            handle: ".btn_order",
            mirror: {
                appendTo: dragContainer.className,
                constrainDimensions: true,
            },
        });


        sortable.on('sortable:stop', (event) => {
            const { oldIndex, newIndex } = event;
            console.warn(">", event)
            this.MoveItemIndex(oldIndex, newIndex)
        });
    }

    private AddEmptyItem() {
        this.data.push(<Data>{})
        this.tabla._UpdateData(this.data)
    }

    private RemoveItem(item: Data) {
        const indexOf = this.data.indexOf(item)
        if (indexOf > -1) {
            this.data.splice(indexOf, 1)
            this.tabla._UpdateData(this.data)
        }
    }

    private MoveItemIndex(oldIndex: number, newIndex: number) {
        if (oldIndex !== newIndex) {
            const movedItem = this.data.splice(oldIndex, 1)[0];
            this.data.splice(newIndex, 0, movedItem);
            this.tabla._UpdateData(this.data);
        }
    }

    // ***********************************************************************
    // PUBLIC METHODS
    // ***********************************************************************

    public _SetData(data: Data[]) {
        this.data = [...(data || [])]
        this.tabla._UpdateData(this.data)
    }

    public _GetData(): Data[] {
        return [...this.data]
    }

    public _RefreshUI(): this {
        this.tabla._RefreshView()
        return this
    }
}